import getToken from '@/utils/getToken';
import { partnerRoles } from '@/constants';
import { useAppStore } from '@/stores/useAppStore';
import { useAuth0 } from '@/auth/index';
import { useDeAuth } from '@/auth/deAuth';
import { reportFatalError } from '@/utils/storeErrorReporting';
import { getAuthFailedError } from '@/utils/errorMessages';

export const createPayload = async (data) => {
    const auth = useAuth0();
    const de = useDeAuth();
    const appStore = useAppStore();

    try {
        const { mode: appMode } = appStore;
        const token = partnerRoles.includes(appMode) ? await getToken(auth) : await de.getTokenSilently();

        return { data, token };
    } catch (error) {
        reportFatalError(error, getAuthFailedError());
        throw error;
    }
};
